export function IntranetHome() {
  return (
    <>
      <div id="div_right">
        <iframe
          id="contractors"
          src="https://intranet.magno-it.nl/contractors"
        ></iframe>
      </div>

      <div id="div_left">
        <div id="div-top"></div>
        <iframe
          id="dropbox"
          src="https://intranet.magno-it.nl/dropbox"
        ></iframe>
      </div>

      <div id="div_middle">
        <div id="div_middle_placements">
          <iframe
            id="placements"
            src="https://intranet.magno-it.nl/placements?tables=c,cm"
          ></iframe>
        </div>
      </div>
    </>
  )
}
